import React from 'react';
import { Card, Collapse, Spin, Typography } from 'antd';
import SyntaxHighlighter from '../SyntaxHighlighter/SyntaxHighlighter';
import ClipboardCopyButton from '../../ClipboardCopyButton';
const { Text } = Typography;
const { Panel } = Collapse;

const Response = (props) => {
  const { loading, error, response } = props;
  if (loading) {
    return (
      <div className="response-loading">
        <Spin />
        <Text>Sending request...</Text>
      </div>
    );
  }

  if (error) {
    return (
      <div className="response-error">
        <Text type="danger">Error: {error}</Text>
      </div>
    );
  }

  if (!response) {
    return null;
  }
  return (
    <div className="response-section">
      <Card
        title="Response"
        extra={
          <ClipboardCopyButton
            data={JSON.stringify(response, null, 2)}
            toolTipText="Copy response"
            onClickCallback={(event) => event.stopPropagation()}
          />
        }
      >
        <div className="response-status">
          <Text strong>Status: </Text>
          <Text type={response.status >= 200 && response.status < 300 ? 'success' : 'danger'}>
            {response.status} {response.statusText}
          </Text>
        </div>

        <Collapse>
          <Panel header="Headers" key="headers">
            <SyntaxHighlighter code={response.headers} language="json" />
          </Panel>

          <Panel header="Body" key="body">
            <SyntaxHighlighter code={response.data} language="json" />
          </Panel>
        </Collapse>
      </Card>
    </div>
  );
};

export default Response;
